import type { PremiumAsset as PremiumAssetType } from '@wix/ambassador-premium-asset-v2-premium-asset/types';

export class PremiumAssets {
  constructor(private readonly premiumAssets: PremiumAssetType[]) {}

  isEmpty(): boolean {
    return this.premiumAssets.length === 0;
  }
}
